export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

/** Массив не отсекаем, в отличие от `isRecord`: ключей ответа у него нет, результат и так `undefined`. */
export function readProp(value: unknown, key: string): unknown {
  return typeof value === 'object' && value !== null
    ? (value as Record<string, unknown>)[key]
    : undefined;
}

export function toArray(value: unknown): unknown[] {
  return Array.isArray(value) ? value : [];
}

export function toNumber(value: unknown): number | null {
  return typeof value === 'number' && Number.isFinite(value) ? value : null;
}

/** Обрезаем: бэкенд отдаёт имена с хвостовыми пробелами; пустая строка — «значения нет». */
export function toText(value: unknown): string | null {
  if (typeof value !== 'string') {
    return null;
  }
  const text = value.trim();
  return text === '' ? null : text;
}

/** Id на бэкенде числовые, в моделях строковые; строку не обрезаем — из id считается `cartLineKey`. */
export function toId(value: unknown): string | null {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? String(value) : null;
  }
  return typeof value === 'string' && value.trim() !== '' ? value : null;
}
